export const SESSION_KEYS = {
  USER_EMAIL: 'userEmail',
  RESET_PASSWORD_TOKEN: 'xbpRPToken',
} as const;

export const FORM_FIELDS = {
  NEW_PASSWORD: 'new_password',
  CONFIRM_PASSWORD: 'confirm_password',
} as const;
